import React, { useEffect } from 'react';
import type { FC } from 'react';
import type { RadioChangeEvent } from 'antd';
import { Card, Radio, Space, Image } from 'antd';

interface CardProps {
  /** 题目的图片链接 */
  src: string;
  /** 答案组 */
  answers: API.answer[];
  /** 选择的答案 */
  selectAnswer: string;
  /** 选项改变 */
  onChange: (val: RadioChangeEvent) => void
}

/** 单选题 */
export const RadioCard: FC<CardProps> = ({ src, answers, selectAnswer, onChange }) => {
  /** 选择改变 */
  const onRadioChange = (e: RadioChangeEvent) => {
    onChange(e);
  };
  return (
    <Card bordered={false}>
      <Image src={src} width="625px" />
      <Radio.Group onChange={onRadioChange} value={selectAnswer} >
        <Space direction="vertical">
          {answers.map((item) => (
            <Radio value={item.label} key={item.content}>
              {item.content}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
    </Card>
  );
};